module.exports = __webpack_public_path__ + "img/52_16.03f63cbb.png";